import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    // If not authenticated, redirect to login page
    return <Navigate to="/" />;
  }

  // If authenticated, render the children (protected route content)
  return children;
};

export default PrivateRoute;
